import Navigator from 'app';
import BillModel from './bill_model';
const NewestBillsCollection = Backbone.Collection.extend({
  model: BillModel,
  url: Navigator.config.api_base + 'bills/new'
});
const API = {
  getNewBills: function () {
    const defer = new $.Deferred();
    const newBills = new NewestBillsCollection();
    newBills.fetch({
      success: function (data) {
        defer.resolve(data);
      },
      error: function (error) {
        console.error('New bill list not available');
        defer.reject(error);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("bills:new", function () {
  return API.getNewBills();
});
export { NewestBillsCollection as default };